import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { message } from 'antd';
import Util from '../../../script/util';
import Scrollbar from 'react-scrollbars-custom';
import './step3.scss';
import { connect } from 'react-redux';

class categoryList extends Component {
  changeCheckItem = (type) => {
    const { checkList } = this.props;
    const isCheck = checkList.findIndex((item) => item === type.categoryId);
    const arr = JSON.parse(JSON.stringify(checkList));
    if (isCheck !== -1) {
      arr.splice(isCheck, 1);
    } else {
      type != null && arr.push(type.categoryId);
    }

    // 最多选择12个
    if (arr.length > 12) {
      message.warning('最多选择12个哦~');
      return;
    }

    if (type) {
      if (arr && arr.length) {
        this.props.nextBtnStatus(false, '完成');
      } else {
        this.props.nextBtnStatus(true, '至少选择1个');
      }
    }

    this.setState({ checkList: arr });
    this.props.change(arr);
  };

  render() {
    const { cateList, checkList } = this.props;

    return (
      <div className="perfect-step-3">
        <div className="step-header">
          <h2 className="step-title">你最感兴趣的内容是？</h2>
        </div>
        <div className="cate-wrapper">
          <Scrollbar className="parent-scroll">
            <div className="cate-box">
              {cateList && cateList.length
                ? cateList.map((item) => (
                    <div
                      key={item.categoryId}
                      className={`cate-item${checkList.indexOf(item.categoryId) !== -1 ? ' active' : ''}`}
                      onClick={() => this.changeCheckItem(item)}
                    >
                      <div className="game-icon">
                        <img src={Util.transImgUrl(item.icon)} alt="" />
                      </div>
                      <p className="cate-text">{item.name}</p>
                    </div>
                  ))
                : null}
            </div>
          </Scrollbar>
        </div>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(categoryList, { withRef: true })
);
